import { gql } from '@apollo/client';

export const DELETE_AD = gql`
  mutation DeleteAd($id: ID!, $adType: AdTypeEnum = VACANCY) {
    deleteAd(input: { id: $id, adType: $adType }) {
      status
    }
  }
`;
